// Generated by `python manage.py build_support_kb` from
// backend/apps/support/kb/suggested_questions.json and the page guides
// (scripts/regen_support_kb.sh). Do not edit by hand.
/**
 * The empty chat panel's suggested questions, per persona: the question and
 * the page it is about. The panel only shows a question whose page is in the
 * user's allowed routes. Never sent to the model as context (#3679).
 */
export const SUGGESTED_QUESTIONS: Readonly<
  Record<string, ReadonlyArray<readonly [question: string, route: string]>>
> = {
  "agent": [
    ["How do I add a new contact?", "/crm/contacts"],
    ["How do I capture a sale?", "/crm/deals"],
    ["Where do I book a viewing?", "/crm/appointments"],
    ["How do I upload a signed mandate?", "/crm/document-vault"],
    ["How do I load a new listing?", "/crm/listings"],
    ["How do I capture a new buyer?", "/crm/buyers"],
    ["How do I add a follow-up call?", "/crm/tasks"],
    ["What is on for me today?", "/crm/dashboard"],
    ["How much commission am I still owed?", "/crm/commission"],
    ["How close am I to my target?", "/crm/targets"],
    ["Where do I rank against other agents?", "/crm/leaderboard"],
    ["Which FICA documents do I still need?", "/crm/fica-matrix"],
    ["How do I check who owns a property?", "/crm/property-lookup"],
    ["How do I get an owner's cell number?", "/crm/property-lookup"],
    ["Which farm properties have new owners?", "/crm/farm"],
    ["How do I refer a buyer to a colleague?", "/crm/referrals"],
    ["How do I email a contact?", "/crm/messaging"],
    ["How do I send a WhatsApp to a client?", "/crm/messaging"],
    ["Where do I log today's canvassing?", "/crm/kpis"],
    ["How do I confirm my KPI figures?", "/crm/kpi-confirm"],
    ["How do I upload my new Fidelity certificate?", "/crm/my-documents"],
    ["Where is the offer to purchase template?", "/crm/document-vault"],
    ["Which of my deals await sign-off?", "/crm/deals"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "admin": [
    ["What needs doing today?", "/admin/dashboard"],
    ["How do I add a new staff member?", "/admin/users"],
    ["How do I deactivate a user who left?", "/admin/users"],
    ["How do I put agents into a team?", "/admin/users"],
    ["How do I give an agent a farm area?", "/admin/users"],
    ["How do I approve a commission split?", "/admin/commission-authorizations"],
    ["How do I record commission received?", "/admin/commission"],
    ["What commission is still owed to agents?", "/admin/commission"],
    ["How do I download the commission sheet?", "/admin/commission-sheet"],
    ["What registered this month?", "/admin/monthly-deals"],
    ["Which deals have an overdue deposit?", "/admin/deal-pipeline"],
    ["How are we doing against target?", "/admin/dashboard"],
    ["How do I set an agent's yearly target?", "/admin/sales-targets"],
    ["How do I hand a lead to an agent?", "/admin/leads/unassigned"],
    ["How do I merge duplicate contacts?", "/admin/contacts/dedup"],
    ["How do I email agents their scorecards?", "/admin/kpis"],
    ["How do I close off a KPI month?", "/admin/kpi-scorecard"],
    ["How do I approve a high-risk FICA case?", "/admin/compliance"],
    ["Whose Fidelity certificate expires soon?", "/admin/compliance/agents"],
    ["How do I give an agent a payslip?", "/admin/payslips"],
    ["Who has not used the CRM this month?", "/admin/agent-usage"],
    ["How do I add a missing area?", "/admin/areas"],
    ["How do I add a training video?", "/admin/training"],
    ["How do I change our logo?", "/admin/business"],
    ["Has my reported problem been fixed?", "/admin/feedback/reports"],
  ],
  "paralegal": [
    ["Which files need me most?", "/paralegal"],
    ["How do I capture a sale for an agent?", "/paralegal"],
    ["How do I see one agent's files?", "/paralegal"],
    ["Which deals have lodged?", "/paralegal"],
    ["Which legal file is most at risk?", "/legal"],
    ["What do the badges on a file mean?", "/legal"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["How do I ask for a date extension?", "/behind-schedule"],
    ["How do I add a new conveyancing firm?", "/crm/conveyancers"],
    ["Where is a conveyancer's number?", "/crm/conveyancers"],
    ["How do I generate a letter for a client?", "/crm/documents"],
    ["How do I re-file a misfiled document?", "/crm/document-vault"],
    ["Where is the offer to purchase template?", "/crm/document-vault"],
    ["What tasks are due today?", "/crm/tasks"],
    ["How do I add a new staff member?", "/crm/users"],
    ["How do I deactivate a user who left?", "/crm/users"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "finance": [
    ["How do I pay commission on a deal?", "/finance"],
    ["How do I approve a commission split?", "/finance/authorizations"],
    ["How do I send a split back?", "/finance/authorizations"],
    ["How do I generate a commission run?", "/finance-accounts"],
    ["How do I make sure a referral is paid?", "/finance"],
    ["How do I see one agent's payouts?", "/finance"],
    ["Where is last month's commission sheet?", "/crm/commission-sheet"],
    ["Which commission has not come in yet?", "/crm/commission-sheet"],
    ["Which deals are outstanding over 90 days?", "/crm/outstanding-deals"],
    ["Is a deal ready to be paid?", "/crm/finance/fica-outstanding"],
    ["What commission is expected soon?", "/crm/finance/deals-lodged"],
    ["How do I give an agent a payslip?", "/crm/payslips"],
    ["How do I email a payslip to an agent?", "/crm/payslips"],
    ["What is our market share by area?", "/crm/market-share"],
    ["How do I rank agents for a period?", "/crm/leaderboard"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["Where is a conveyancer's number?", "/crm/conveyancers"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "finance_accounts": [
    ["How do I generate a commission run?", "/finance-accounts"],
    ["Where are the deposits to invest?", "/finance-accounts"],
    ["How do I approve a commission split?", "/finance/authorizations"],
    ["How do I send a split back?", "/finance/authorizations"],
    ["Where is last month's commission sheet?", "/crm/commission-sheet"],
    ["Which commission has not come in yet?", "/crm/commission-sheet"],
    ["Which deals are outstanding over 90 days?", "/crm/outstanding-deals"],
    ["Is a deal ready to be paid?", "/crm/finance/fica-outstanding"],
    ["What commission is expected soon?", "/crm/finance/deals-lodged"],
    ["How do I give an agent a payslip?", "/crm/payslips"],
    ["How do I email a payslip to an agent?", "/crm/payslips"],
    ["What is our market share by area?", "/crm/market-share"],
    ["How do I rank agents for a period?", "/crm/leaderboard"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["Where is a conveyancer's number?", "/crm/conveyancers"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "accounts": [
    ["Which deposits can I invest today?", "/accounts"],
    ["How do I send a deposit-ready notice?", "/accounts"],
    ["What is holding a deposit up?", "/accounts"],
    ["Which deal files need attention?", "/paralegal"],
    ["Which deals have lodged?", "/paralegal"],
    ["Which legal file is most at risk?", "/legal"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["How do I add a new conveyancing firm?", "/crm/conveyancers"],
    ["Where is a conveyancer's number?", "/crm/conveyancers"],
    ["How do I find an attorney firm?", "/crm/partners"],
    ["How do I generate a letter for a client?", "/crm/documents"],
    ["How do I re-file a misfiled document?", "/crm/document-vault"],
    ["What tasks are due today?", "/crm/tasks"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "manager": [
    ["How do I sign off a deal?", "/management"],
    ["How do I send a deal back to the agent?", "/management"],
    ["How do I capture a sale for an agent?", "/paralegal"],
    ["Which deals are waiting on one thing?", "/crm/oversight/deal-queue"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["Where are last month's deal figures?", "/crm/oversight/monthly-deals"],
    ["Which deals are at the attorneys?", "/crm/oversight/deal-pipeline"],
    ["How are agents doing against target?", "/crm/targets"],
    ["How do I rank agents for a period?", "/crm/leaderboard"],
    ["Where are last month's KPI results?", "/crm/oversight/kpis"],
    ["How do I close off a KPI month?", "/crm/oversight/kpi-scorecard"],
    ["How do I sign off KPI exceptions?", "/crm/oversight/kpi-exceptions"],
    ["Who has not used the CRM this month?", "/crm/oversight/agent-usage"],
    ["What did each agent do this week?", "/crm/oversight/activity"],
    ["Whose Fidelity certificate expires soon?", "/crm/compliance/agents"],
    ["Which messages did not go through?", "/crm/oversight/communications"],
    ["What is our market share by area?", "/crm/oversight/market-share"],
    ["How do I add a new staff member?", "/crm/users"],
    ["How do I give an agent a farm area?", "/crm/users"],
    ["How do I top up someone's lookups?", "/crm/users"],
    ["How do I import a farm book?", "/crm/farm-book-import"],
    ["How do I generate a letter for a client?", "/crm/documents"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "office_admin": [
    ["How do I load a new listing?", "/crm/listings"],
    ["How do I find a listing?", "/crm/listings"],
    ["How do I import a farm book?", "/crm/farm-book-import"],
    ["What farm books were imported before?", "/crm/farm-book-import"],
    ["Where is the offer to purchase template?", "/crm/document-vault"],
    ["How do I re-file a misfiled document?", "/crm/document-vault"],
    ["What is on for me today?", "/crm/dashboard"],
    ["How do I add a follow-up call?", "/crm/tasks"],
    ["What tasks are due today?", "/crm/tasks"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I take a training questionnaire?", "/crm/training"],
    ["How do I update my phone number or email?", "/crm/settings"],
    ["How do I change my password?", "/crm/settings"],
    ["How do I connect ChatGPT or Claude?", "/crm/connect"],
  ],
  "hr": [
    ["Whose Fidelity certificate expires soon?", "/crm/compliance/agents"],
    ["How do I record a renewed certificate?", "/crm/compliance/agents"],
    ["How do I add an annexure to a contract?", "/crm/compliance/agents"],
    ["Why is an agent not compliant?", "/crm/compliance/agents"],
    ["How do I add a new staff member?", "/crm/users"],
    ["How do I deactivate a user who left?", "/crm/users"],
    ["How do I give an agent a farm area?", "/crm/users"],
    ["Which of my documents need attention?", "/crm/my-documents"],
    ["How do I add a follow-up call?", "/crm/tasks"],
    ["What tasks are due today?", "/crm/tasks"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I update my phone number or email?", "/crm/settings"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "hr_paralegal": [
    ["Which files need me most?", "/paralegal"],
    ["How do I capture a sale for an agent?", "/paralegal"],
    ["Whose Fidelity certificate expires soon?", "/crm/compliance/agents"],
    ["How do I record a renewed certificate?", "/crm/compliance/agents"],
    ["How do I see one agent's files?", "/paralegal"],
    ["Which deals have lodged?", "/paralegal"],
    ["How do I add an annexure to a contract?", "/crm/compliance/agents"],
    ["Why is an agent not compliant?", "/crm/compliance/agents"],
    ["Which legal file is most at risk?", "/legal"],
    ["What do the badges on a file mean?", "/legal"],
    ["Which deals are behind schedule?", "/behind-schedule"],
    ["How do I ask for a date extension?", "/behind-schedule"],
    ["How do I add a new conveyancing firm?", "/crm/conveyancers"],
    ["Where is a conveyancer's number?", "/crm/conveyancers"],
    ["How do I generate a letter for a client?", "/crm/documents"],
    ["How do I re-file a misfiled document?", "/crm/document-vault"],
    ["Where is the offer to purchase template?", "/crm/document-vault"],
    ["What tasks are due today?", "/crm/tasks"],
    ["How do I add a new staff member?", "/crm/users"],
    ["How do I deactivate a user who left?", "/crm/users"],
    ["How do I give an agent a farm area?", "/crm/users"],
    ["Which of my documents need attention?", "/crm/my-documents"],
    ["How do I add a follow-up call?", "/crm/tasks"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I update my phone number or email?", "/crm/settings"],
    ["How do I change my password?", "/crm/settings"],
  ],
  "canvasser": [
    ["How do I find a property in the farm?", "/crm/farm"],
    ["How do I log a canvassing call?", "/crm/farm"],
    ["How do I capture an owner's number?", "/crm/farm"],
    ["How do I mark an owner do not contact?", "/crm/farm"],
    ["Which farm properties have new owners?", "/crm/farm"],
    ["Which properties sold under a price?", "/crm/farm"],
    ["How do I check who owns a property?", "/crm/property-lookup"],
    ["How do I save an owner to contacts?", "/crm/canvassing"],
    ["How do I add a new contact?", "/crm/contacts"],
    ["How do I find a contact?", "/crm/contacts"],
    ["How do I add a follow-up call?", "/crm/tasks"],
    ["What tasks are due today?", "/crm/tasks"],
    ["What appointments do I have next week?", "/crm/appointments"],
    ["Where are the training videos?", "/crm/training"],
    ["How do I change my password?", "/crm/settings"],
  ],
};
